import React from 'react';
import { filterParameters, getParameterIcon, formatKey, formatValue, capitalizeFirstLetter } from '@/components/shared/research-utils';
import { getCountryDisplayName } from '@/lib/countries';

interface ParametersListSectionProps {
  parameters: Record<string, any>;
}

export const ParametersListSection: React.FC<ParametersListSectionProps> = ({ 
  parameters 
}) => {
  const { locationParams, sourceParams, mainParams } = filterParameters(parameters);
  const hasAnyParams = locationParams.length > 0 || sourceParams.length > 0 || mainParams.length > 0;

  if (!hasAnyParams) return null;

  return (
    <div className="space-y-3">
      {/* Location Parameters */}
      {locationParams.map(([key, value]) => {
        if (!value) return null;
        
        const displayValue = key === 'country' ? getCountryDisplayName(value) : value;
        
        return (
          <div key={key} className="flex items-center gap-3 p-3 bg-background/50 dark:bg-background/80 rounded-2xl border">
            {getParameterIcon(key, parameters)}
            <div className="flex-1">
              <div className="font-medium text-sm text-foreground">{formatKey(key)}</div>
              <div className="text-sm text-muted-foreground">{displayValue}</div>
            </div>
          </div>
        );
      })}

      {/* Source Parameters */}
      {sourceParams.map(([key, value]) => {
        if (!value) return null;
        
        return (
          <div key={key} className="flex items-center gap-3 p-3 bg-background/50 dark:bg-background/80 rounded-2xl border">
            {getParameterIcon(key, parameters)}
            <div className="flex-1">
              <div className="font-medium text-sm text-foreground">Source Type</div>
              <div className="text-sm text-muted-foreground">{capitalizeFirstLetter(formatValue(value))}</div>
            </div>
          </div>
        );
      })}

      {/* Main Parameters */}
      {mainParams.map(([key, value]) => (
        <div key={key} className="flex items-center gap-3 p-3 bg-background/50 dark:bg-background/80 rounded-2xl border">
          {getParameterIcon(key, parameters)}
          <div className="flex-1">
            <div className="font-medium text-sm text-foreground">{formatKey(key)}</div>
            <div className="text-sm text-muted-foreground">{capitalizeFirstLetter(formatValue(value))}</div>
          </div>
        </div>
      ))}
    </div>
  );
}; 